import { render, staticRenderFns } from "./ParametrizacaoEdi.vue?vue&type=template&id=ee60b2c4"
import script from "./ParametrizacaoEdi.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoEdi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports